import React, { useEffect } from 'react';
// Icons
import speaker from '../../style/assets/icons/speaker.png';
import speakerOff from '../../style/assets/icons/speakerOff.png';
import copyright from '../../style/assets/icons/copyright.png';
import subtitles from '../../style/assets/icons/subtitles.png';
import subtitlesOff from '../../style/assets/icons/subtitlesOff.png';

export const Menu = (props: any) => {
	useEffect(() => {}, [props.sound]);

	return (
		<React.Fragment>
			<div
				id='button1'
				className='clickable'
				onClick={() => {
					props.toggleSound();
				}}
				style={{
					position: 'absolute',
					top: '20px',
					right: '20px',
					width: '30px',
					height: '30px',
					zIndex: 20000,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',

					borderRadius: '50%',
					backgroundColor: 'rgba(0, 0, 0, 0.2)',
					backgroundImage: props.sound ? `url(${speaker})` : `url(${speakerOff})`,
					backgroundSize: '20px 20px',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
				}}
			></div>
		</React.Fragment>
	);
};
